module.exports = {"540330100":"草卡镇","540330101":"边坝镇","540330200":"马武乡","540330201":"热玉乡","540330202":"尼木乡","540330203":"沙丁乡","540330204":"金岭乡","540330205":"加贡乡","540330206":"马秀乡","540330207":"都瓦乡","540330208":"拉孜乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540330.json
// module id = 2519
// module chunks = 0